<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>

      

      <el-form-item label="总股池" prop="totalPool">
        <el-input v-model="form.totalPool"></el-input>
      </el-form-item>


           <el-form-item label="每股单价" prop="shareprice">
        <el-input v-model="form.shareprice"></el-input>
      </el-form-item>

      <el-form-item label="年底分红时间（01-01）" prop="fdate">
        <el-input v-model="form.fdate" placeholder="例子：01-01" ></el-input>
      </el-form-item>



      <el-form-item label="每推广一人奖励多少股权" prop="tg_equity_reward">
        <el-input v-model="form.tg_equity_reward"></el-input>
      </el-form-item>
      
      <el-form-item label="是否开启下单股权赠送" prop="is_open_order_equity">
        <el-switch v-model="form.is_open_order_equity"></el-switch>
      </el-form-item>



      <el-form-item label="进入股权池的条件">
        <div class="rule-table-wrapper">
          <el-table size="small" :data="ruleList" border style="width: 100%">
            <el-table-column prop="cups" label="推广满多少杯" width="200">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.cups" :min="0" placeholder="请输入杯数" size="small" style="width: 100%"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="shares" label="获得共享股权比例" width="200">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.shares" :min="0" placeholder="请输入股份" size="small" style="width: 100%"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="deleteRule(scope.$index)" type="text" size="small" style="color: #F56C6C">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="add-rule-btn">
            <el-button size="small" icon="el-icon-plus" type="primary" @click="addRule">新增规则</el-button>
          </div>
        </div>
      </el-form-item>

    </el-form>


    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import EquityApi from '@/api/equity.js';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        status: false,
      },
      ruleList: [],
      setting: [],
      loading: false,
      isProductUpload:false
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      EquityApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data && data.data.vars && data.data.vars.values){
            self.form = data.data.vars.values;
            if(data.data.vars.values.rules){
              self.ruleList = data.data.vars.values.rules;
            }
          }
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      params.rules = self.ruleList;
      self.loading = true;
      EquityApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*新增规则*/
    addRule() {
      this.ruleList.push({
        cups: null,
        shares: null
      });
    },

    /*删除规则*/
    deleteRule(index) {
      this.ruleList.splice(index, 1);
    },

  }
};
</script>

<style>
.rule-table-wrapper {
  width: 100%;
}

.add-rule-btn {
  margin-top: 10px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/equity/setting/getSetting.vue